<script setup>
import LoginView from "../views/LoginView.vue";
import ProfileView from "../views/ProfileView.vue";
import { useUserDataStore } from "../stores/userData";
import { useOwnedGamesStore } from "@/stores/ownedGamesStore.js";
import Footer from "@/components/Footer.vue";
import BackButton from "@/components/BackButton.vue";
import Card from "@/components/ui/card/Card.vue";
import CardHeader from "@/components/ui/card/CardHeader.vue";
import HeaderView from "@/views/HeaderView.vue";
import Navigation from "@/components/Navigation.vue";
import CardContent from "@/components/ui/card/CardContent.vue";
import { useBreakpoints, breakpointsTailwind } from "@vueuse/core";
import { computed } from "vue";
import { isDarkMode, toggleDarkMode } from "@/darkmode.js";
import Button from "@/components/ui/button/Button.vue";
import { SunIcon, MoonIcon } from "lucide-vue-next";

const breakpoints = useBreakpoints(breakpointsTailwind);
const isMobile = breakpoints.smaller("lg"); // true if screen width is less than 'lg' breakpoint

const userDataStore = useUserDataStore();
const ownedGamesStore = useOwnedGamesStore();

function saveName(name) {
  userDataStore.setName(name);
}

const username = computed(() => userDataStore.userProfile?.nickname);
const avatarUrl = computed(() => userDataStore.avatarUrl);
const isLoggedIn = computed(() => userDataStore.isLoggedIn);
</script>

<template>
  <div v-if="userDataStore.isLoaded && userDataStore.isLoggedIn">
    <div v-if="!isMobile" class="w-full h-20">
      <Navigation
        :username="username"
        :avatarUrl="avatarUrl"
        :isLoggedIn="isLoggedIn"
      ></Navigation>
    </div>

    <Card
      class="w-full h-full rounded-0 border-0 shadow-none bg-background px-4"
    >
      <CardHeader>
        <HeaderView v-if="isMobile" name="Login"></HeaderView>
      </CardHeader>
      <CardContent class="w-full flex flex-col items-center justify-center">
        <ProfileView
          :avatarUrl="userDataStore.avatarUrl"
          :nickname="userDataStore.userProfile.nickname"
          :steamId="userDataStore.steamId"
          :isPrivate="ownedGamesStore.isPrivate"
          @saveName="saveName"
          :steamUsername="userDataStore.steamName"
        />
        <Button
          v-if="isMobile"
          variant="ghost"
          size="icon-lg"
          @click="toggleDarkMode"
          class="border-2 fixed right-10 top-10"
        >
          <SunIcon v-if="!isDarkMode" class="dark:text-foreground"></SunIcon>
          <MoonIcon v-if="isDarkMode" class="dark:text-foreground"></MoonIcon>
        </Button>
      </CardContent>
    </Card>
  </div>

  <div v-else-if="userDataStore.isLoaded && !userDataStore.isLoggedIn">
    <div v-if="!isMobile" class="w-full h-20">
      <Navigation
        :username="username"
        :avatarUrl="avatarUrl"
        :isLoggedIn="isLoggedIn"
      ></Navigation>
    </div>

    <Card
      class="w-full h-full rounded-0 border-0 shadow-none bg-background px-4"
    >
      <CardHeader>
        <HeaderView v-if="isMobile" name="Login"></HeaderView>
      </CardHeader>

      <CardContent class="w-full flex flex-col items-center justify-center">
        <LoginView />
      </CardContent>
    </Card>
  </div>

  <div v-else class="loading">
    <p>Loading user data...</p>
  </div>

  <Footer v-if="isMobile"></Footer>
</template>
